module.exports = __webpack_public_path__ + "static/media/slayer_homepage.518219a4.png";